// Standard 12px data table with mono-uppercase headers and dashed-hairline
// row separators. Children are <thead><tr><th>...</th></tr></thead> + <tbody>.
// Provides only the table chrome — content/columns are caller-owned.

export function Table({ children, className = '' }) {
  return (
    <table className={`w-full border-collapse text-[12px] ${className}`}>
      {children}
    </table>
  );
}

// Helper Th/Td so callers don't repeat the cell styling verbatim.
export function Th({ children, className = '' }) {
  return (
    <th
      className={[
        'text-left px-2.5 py-2 font-mono text-eyebrow uppercase text-ink-3',
        'border-b border-ink',
        className,
      ].join(' ')}
    >
      {children}
    </th>
  );
}

export function Td({ children, className = '', style }) {
  return (
    <td
      className={[
        'text-left px-2.5 py-2',
        'border-b border-dashed border-hairline',
        className,
      ].join(' ')}
      style={style}
    >
      {children}
    </td>
  );
}

export default Table;
